const BASE_ENDPOINT = '/provider-accreditation-service/resources';

function mountEndpoint(endpoint: string, prefix: string = BASE_ENDPOINT): string {
  return `${prefix}${endpoint}`;
}

export const FOUNDATION_ENDPOINTS = {
  INFORMATION: mountEndpoint('/information'),
  REFRESH: mountEndpoint('/authentication'),
  REVOKE: mountEndpoint('/logout'),
  THEME: mountEndpoint('/configuration'),
};
const POST = {
  SEND_DOCUMENT: mountEndpoint('/provider/:nrSeqUser/documents/:nrSeqAccreditation/attachment'),
  AMOUNT_PROFESSIONALS: mountEndpoint('/provider/:nrSeqUser/people-management/:nrSeqAccreditation/amount-professionals'),
  AUDIT_FUNCTION: mountEndpoint('/audit/function'),
  ACCREDITATION_SEND: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation/type/:nrSeqTypeAccreditation/send'),
  CHANGE_PASSWORD: mountEndpoint('/provider/:nrSeqUser/change-password'),
  CONFIRM_APPOINTMENT: mountEndpoint('/technical-visit/confirm-appointment/:nrSeqAppointment'),
  ESTABLISHMENT_SPECIALTY: mountEndpoint('/provider/:nrSeqUser/establishments-specialties'),
  EDIT_NEGOTIATION_PROPOSAL_ITEM: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/itens'),
  EDIT_NEGOTIATION_CONTRACT_DRAFT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposal/:nrSeqProposal/change-draft'),
  INSERT_ATTACHMENT: mountEndpoint('/provider/:nrSeqUser/calls/:nrSeqCall/insert-attachment'),
  INSERT_ATTACHMENT_NEGOTIATION: mountEndpoint('/negotiation/:nrSeqNegotiation/insert-attachment'),
  NEW_CALL: mountEndpoint('/new-call'),
  NEW_DOCTOR: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/clinical-staff'),
  NEW_NEGOTIATION_HISTORY: mountEndpoint('/negotiation/:nrSeqNegotiation/history'),
  NEW_PASSWORD: mountEndpoint('/user/new-password/:hash'),
  NEW_USER: mountEndpoint('/new-user'),
  NEW_USER_CONFIRMATION: mountEndpoint('/confirm-user/:hash'),
  EMPLOYEE: mountEndpoint('/provider/:nrSeqUser/people-management/:nrSeqAccreditation/employee'),
  QUALIFICATION: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/qualification'),
  QUESTIONNAIRE_METADATA: mountEndpoint('/provider/:nrSeqUser/questionnaires/:nrSeqAccreditation'),
  RENEW_PASSWORD_BY_NRSEQ: mountEndpoint('/renew-password/:nrSequence'),
  RESET_PASSWORD: mountEndpoint('/user/reset-password'),
  UPLOAD_FILE: mountEndpoint('/files/upload'),
  UPDATE_DOCTOR_DATA: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/clinical-staff/:nrSeqDoctor'),
  OUTSOURCED_SERVICES: mountEndpoint('/provider/:nrSeqUser/people-management/:nrSeqAccreditation/outsourced-services'),
  CLOSE_ACCOUNT: mountEndpoint('/provider/:nrSeqUser/account-closure'),
  NOTIFICATION_UPDATE_TO_READ: mountEndpoint('/:nrSeqUser/notifications/mark-as-read'),
  NOTIFICATION_UPDATE_ALL_TO_READ: mountEndpoint('/:nrSeqUser/notifications/mark-all-as-read'),
  GENERATE_ACCREDITATION: mountEndpoint('/wizard-steps'),
  BEDS: mountEndpoint('/user/:nrSeqUser/beds/:nrSeqAccreditation'),
  MATERIALS: mountEndpoint('/provider/:nrSeqUser/accreditation/:nrSeqAccreditation/materials'),
  EQUIPMENTS: mountEndpoint('/user/:nrSeqUser/equipments/:nrSeqAccreditation'),
  REJECT_APPOINTMENT: mountEndpoint('/technical-visit/reject-appointment/:nrSeqAppointment'),
  PROCEDURES: mountEndpoint('/user/:nrSeqUser/procedures'),
  SERVICES: mountEndpoint('/user/:nrSeqUser/services'),
  FORM_TECHNICAL_VISIT: mountEndpoint('/form-technical-visit/:nrSeqVisit'),
  TECHNICAL_VISIT_ATTACHMENTS: mountEndpoint('/technical-visit/insert-attachment'),
  TECHNICAL_VISIT_FINISH: mountEndpoint('/technical-visit/:nrSeqVisit/finish/:nrSeqForm'),
  TECHNICAL_VISIT_INCONSISTENCY_ACTION: mountEndpoint('/technical-visit/:nrSeqVisit/inconsistencies/register-action'),
  TECHNICAL_VISIT_POSTPONE_ANSWER: mountEndpoint('/technical-visit/:nrSeqVisit/inconsistencies/change-date'),
  TECHNICAL_VISIT_REPORT: mountEndpoint('/technical-visit/:nrSeqVisit/report'),
  NEGOTIATION_PROPOSAL_REJECT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/reject'),
  NEGOTIATION_PROPOSAL_ACCEPT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/accept'),
  NEGOTIATION_NEW_PROPOSAL: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/new-proposal'),
  NEGOTIATION_REPORT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/report'),
  CANCELING_ACCREDITATION: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation/cancel-request'),
  TERMS: mountEndpoint('/terms'),
  PACKAGE: mountEndpoint('/accreditation/:nrSeqAccreditation/package'),
  PACKAGE_UPDATE: mountEndpoint('/accreditation/:nrSeqAccreditation/package/update'),
};

const GET = {
  ACCREDITATION_AUTOCOMPLETE: mountEndpoint('/users/:nrSeqUser/providers-accreditations/autocomplete'),
  ACCREDITATION: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation'),
  ACCREDITATION_PENDENCES: mountEndpoint('/:nrSeqUser/validation/:nrSeqAccreditation/pendencies'),
  ACCREDITATION_STATUS: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation/status'),
  ADDRESS_BY_CODE: mountEndpoint('/addresses/postal-codes/:postalCode'),
  CALL_ATTACHMENT_DOWNLOAD: mountEndpoint('/provider/:nrSeqUser/calls/attachments/:nrSeqAttachment/table/:ieTable/download'),
  CHECK_TERMOS_USO: mountEndpoint('/provider/:nrSeqUser/term-of-use/check'),
  CHECK_TIPO_ANEXOS: mountEndpoint('/'),
  CHECK_PRIVACY_WARNING: mountEndpoint('/provider/:nrSeqUser/privacy-warning/check'),
  DETAILS_CALL: mountEndpoint('/provider/:nrSeqUser/calls/:nrSeqCall'),
  DOCTOR: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/clinical-staff/:nrSeqDoctor'),
  DOWNLOAD: mountEndpoint('/provider/:nrSeqUser/:nmTable/:nrSeqAttachment/download'),
  DOWNLOAD_ATTACHMENT_CALL: mountEndpoint('/provider/:nrSeqUser/calls/attachments/:nrSeqAttachment/table/:nmTable/download'),
  DOCTOR_SPECIALTIES: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/clinical-staff/:nrSeqDoctor/specialties'),
  LOGIN_USER: mountEndpoint('/user/:username'),
  MY_DATA_USER: mountEndpoint('/provider/:nrSeqUser/my-data/user'),
  NEGOTIATION_ATTACHMENT: mountEndpoint('/negotiation/:nrSeqNegotiation/download/:nrSeqAttachment'),
  NEGOTIATION_DETAIL: mountEndpoint('/negotiation/:nrSeqNegotiation'),
  NEGOTIATION_DRAFT_ATTACHMENT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposal/:nrSeqProposal/download/:nrSeqItemProposal'),
  NEGOTIATION_DRAFT: mountEndpoint('/negotiation/:nrSeqNegotiation/proposal/:nrSeqProposal/clauses/:nrSeqItemProposal'),
  NOTIFICATIONS_UNREAD: mountEndpoint('/:nrSeqUser/notifications/notifications-unread'),
  PRIVACY_WARNING: mountEndpoint('/terms/PA'),
  PRIVACY_WARNING_CURRENT: mountEndpoint('/provider/:nrSeqUser/privacy-warning/current'),
  PREVIEW_FILE: mountEndpoint('/preview-files?uri='),
  PROVIDER_ESTABLISHMENT_ATTACHMENT: mountEndpoint('/provider/:nrSeqUser/types-providers-accreditations/:nrSeqTypeAccreditation/attachment-types'),
  PROVIDER_ESTABLISHMENT_ITEM: mountEndpoint('/provider/:nrSeqUser/establishment/accreditation/:nrSeqAccreditation'),
  QUESTIONNAIRE_METADATA: mountEndpoint('/provider/:nrSeqUser/questionnaires/:nrSeqTypeAccreditation'),
  QUESTIONNAIRE_REPLEIS: mountEndpoint('/provider/:nrSeqUser/questionnaires/:nrSeqAccreditation/repleis'),
  REPORT_BY_PATH: mountEndpoint('/report/path/:path'),
  REPORT_BY_GROUP: mountEndpoint('/report/:cdGroup'),
  TERMS: mountEndpoint('/terms'),
  TERMS_OF_USE: mountEndpoint('/terms/TU'),
  TERM_USE_CURRENT: mountEndpoint('/provider/:nrSeqUser/term-of-use/current'),
  TYPE_ACCREDITATION: mountEndpoint('/provider/:nrSeqUser/types-providers-accreditations/:nrSeqTypeAccreditation/term'),
  TYPE_OF_PROVIDER_ACCREDITATION: mountEndpoint('/provider/:nrSeqUser/types-providers-accreditations/:nrSeqTypeAccreditation'),
  FILE_TEMPLATES_DOCUMENTS: mountEndpoint('/provider/:nrSeqUser/documents/:nrSeqAccreditation/file-templates'),
  ESTABLISHMENT_SPECIALTY: mountEndpoint('/medical-specialty/:code'),
  GUIDANCE_MANUAL: mountEndpoint('/users/:nrSeqUser/providers-accreditations/guidance-manual'),
  EQUIPMENTS: mountEndpoint('/user/:nrSeqUser/equipments/:nrSeqAccreditation/:nrSequence'),
  SPECIALTY: mountEndpoint('/provider/:nrSeqUser/establishments-specialties/:nrSeqAccreditation/:nrSequence'),
  FORM_TECHNICAL_VISIT: mountEndpoint('/form-technical-visit/autocomplete/:nrSeqQuestion'),
  FORM_TECHNICAL_VISIT_DATA: mountEndpoint('/technical-visit/:nrSeqVisit/form/:nrSeqForm'),
  TECHNICAL_VISIT_ATTACHMENT_DOWNLOAD: mountEndpoint('/technical-visit/:nrSeqVisit/download/:nrSeqAttachment'),
  PACKAGE_ITEMS: mountEndpoint('/accreditation/:nrSeqAccreditation/package/:nrSeqPackage/items'),
  PACKAGE_COMPOSITION_ITEMS: mountEndpoint('/negotiation/:nrSeqNegotiation/proposals/:nrSeqProposal/itens/:itemType/item/:nrSeqItemProposal'),
  FILTER_MATERIALS: mountEndpoint('/provider/:nrSeqUser/locator/materials'),
  FILTER_MATERIALS_PACKAGE: mountEndpoint('/provider/:nrSeqUser/locator/materials/accreditation/:nrSeqAccreditation/package'),
};

const DELETE = {
  ACREDITATION_ATTACHMENT: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation/attachments/:nrSeqAttachment'),
  REMOVE_FILE: mountEndpoint('/files/remove'),
  ESTABLISHMENT_SPECIALTY: mountEndpoint('/provider/:nrSeqUser/establishments-specialties/:nrSeqAccreditation/:nrSequence'),
  MEDICINE_MATERIAL: mountEndpoint('/provider/:nrSeqUser/accreditation/:nrSeqAccreditation/materials/:nrSequence'),
  OUTSOURCED_SERVICES: mountEndpoint('/provider/:nrSeqUser/people-management/:nrSeqAccreditation/outsourced-services/:nrSequence'),
  EMPLOYEE: mountEndpoint('/provider/:nrSeqUser/people-management/:nrSeqAccreditation/employee/:nrSequence'),
  DOCTOR: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/clinical-staff/:nrSeqDoctor'),
  BEDS: mountEndpoint('/user/:nrSeqUser/beds/:nrSeqAccreditation/:nrSequence'),
  EQUIPMENTS: mountEndpoint('/user/:nrSeqUser/equipments/:nrSeqAccreditation/:nrSequence'),
  PROCEDURES: mountEndpoint('/user/:nrSeqUser/procedures/:nrSequence'),
  SERVICES: mountEndpoint('/user/:nrSeqUser/services/:nrSequence'),
  QUALIFICATION: mountEndpoint('/users/:nrSeqUser/accreditation/:nrSeqAccreditation/qualification/:nrSeqQualification'),
  PACKAGE: mountEndpoint('/accreditation/:nrSeqAccreditation/package/:nrSeqPackage'),
};

const PUT = {
  LEGAL_PERSONS: mountEndpoint('/provider/:nrSeqUser/legal-persons/:cdCgc'),
  CONFIRM_READ_PRIVACY_WARNING: mountEndpoint('/provider/:nrSeqUser/privacy-warning/confirm-read'),
  CONFIRM_READ_TERM_USE: mountEndpoint('/provider/:nrSeqUser/term-of-use/confirm-read'),
  PROVIDER_ESTABLISHMENT: mountEndpoint('/users/:nrSeqUser/providers-accreditations/:nrSeqAccreditation'),
  PROVIDER_VALIDATION: mountEndpoint('/:nrSeqUser/validation/:nrSeqAccreditation'),
};

export const Endpoint: { GET: typeof GET; DELETE: typeof DELETE; POST: typeof POST, PUT: typeof PUT } = { GET, DELETE, POST, PUT };
